import {
  FIND_APPEAL,
  FIND_APPEAL_SUCCESS,
  FIND_APPEAL_ERROR,
  RESET_APPEAL
} from '../constants';
import { APPLICANT_TYPES } from '../../constants/applicant';

import { getFindAppeal } from '../../resources';

import { appealSubmitParticipantSelector } from '../gia/selectors';
import { examIdSelector, currentExamSelector } from '../examData/selectors';
import { applicantTypeSelector } from '../applicant/selectors';
import { getUserSnilsSelector } from '../mainData/selectors';
import { getUserSnilsSelector as getChildSnilsSelector } from '../mainDataChild/selectors';
import { snilsValidate } from '../../services/validationRules';
import { saveDraft } from '../draft/actions';

export const findAppeal = (payload = {}) => {
  return (dispatch, getState) => {
    const state = getState();

    const { registration_code } = appealSubmitParticipantSelector(state);
    const applicantType = applicantTypeSelector(state);
    const examId = payload.examId || examIdSelector(state);

    const { type, subject_code, date } = currentExamSelector({
      ...state,
      examData: {
        ...state.examData,
        examId
      }
    });

    let snils;

    if (payload.snils) {
      snils = payload.snils;
    } else if (applicantType === APPLICANT_TYPES.parent) {
      snils = getChildSnilsSelector(state);
    } else {
      snils = getUserSnilsSelector(state);
    }

    if (snils && snils.match(snilsValidate.pattern)) {
      dispatch({ type: FIND_APPEAL });

      const onError = () => {
        dispatch(findAppealError());
        dispatch(saveDraft());
      };

      getFindAppeal({
        snils,
        exam_type: type,
        subject_code,
        reg_code: registration_code,
        exam_date: date
      })
        .then(response => {
          if (response.code === 'SUCCESS' || response.code === 'OK') {
            dispatch(findAppealSuccess(response.data));
            dispatch(saveDraft());
          } else {
            onError();
          }
        })
        .catch(onError);
    }
  };
};

const findAppealSuccess = payload => ({
  type: FIND_APPEAL_SUCCESS,
  payload
});

const findAppealError = () => ({
  type: FIND_APPEAL_ERROR
});

export const resetAppeal = () => ({
  type: RESET_APPEAL
});
